import { render, staticRenderFns } from "./ImageClipper.vue?vue&type=template&id=4e255dea"
import script from "./ImageClipper.vue?vue&type=script&lang=js"
export * from "./ImageClipper.vue?vue&type=script&lang=js"
import style0 from "./ImageClipper.vue?vue&type=style&index=0&id=4e255dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports